export default __webpack_public_path__ + "static/media/puesto.9fb63951.png";